import { useEffect, useRef } from "react";

export function useChatBotScroll(deps: any[]) {
    const endRef = useRef<HTMLDivElement | null>(null);
    const lastScrollTop = useRef(0);
    const isScrollingUpRef = useRef(false);

    useEffect(() => {
        endRef.current?.scrollIntoView({ behavior: "auto" });
    }, deps);

    const handleScroll = (e: any) => {
        const scrollTop = e.target.scrollTop;
        const scrollHeight = e.target.scrollHeight;
        const clientHeight = e.target.clientHeight;

        if (scrollTop < lastScrollTop.current) {
            // Scrolling up
            isScrollingUpRef.current = true;
        } else if (scrollTop > lastScrollTop.current) {
            // Scrolling down
            const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;
            if (isAtBottom) {
                isScrollingUpRef.current = false;
            }
        }

        lastScrollTop.current = scrollTop;
    };

    return { endRef, isScrollingUpRef, handleScroll };
}
